export enum PackageName {
    Basic = 'e-TOLL BASIC',
    Business = 'Business'
}